import {
    SPI,
    BaseElementWidget,
    ViewType,
    SEARCH_WIDGET,
    ActionBarWidget,
    Widget,
  } from '@kunlun/dependencies';
  @SPI.ClassFactory(
    BaseElementWidget.Token({
      viewType: ViewType.Table,
      widget: ['actionBar']
    })
  )
  export class maxBtnWidget extends ActionBarWidget {
    @Widget.Reactive()
    protected get activeCount(): number | undefined {
      return 7
     }
  
  }
  
  